import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/banner3.webp")